<template>
	<section id="newsroom-section" class="section no-padding-top">
        <div class="newsroom">  
            <div class="articles-wrapper">
                <div class="container">
                    <ul class="articles">
                        <li v-for="(article, index) in listing" :key="index">
                            <div class="article" role="group" aria-label="article">
                                <div class="article-info">
                                    <a :href="article.Url" class="article-link">
                                        <h2>{{article.Title}}</h2>
                                        <span aria-hidden="true"></span>
                                    </a>
                                    <p class="details">
                                        <span class="publish-date">{{formatDate(article.PublishDate)}}</span>
                                    </p>
                                    <p class="article-summary it_updated" v-html="truncate(article.Summary, 200, '...')">
                                        {{truncate(article.Summary, 200, '...')}}
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- <pagination v-bind:totalResults="listing.length" :totalPages="result.TotalPages"></pagination> -->
            <pagination></pagination>
        </div>
	</section>
</template>

<script>
	import 'url-search-params-polyfill';
	import SmoothScroll from 'smooth-scroll';
	import { mapState, mapActions, mapMutations } from 'vuex';
	import Pagination from '../components/newsroom-pagination';

	export default {
		props: ['filterid', 'result', 'resource'],
		data: function () {
            return {
			}
		},
		computed: {
            ...mapState({
				loading: state => state.listing.loading,
				listing: state => state.listing.listing,
				specification: state => state.listing.specification,
				currentPage: state => state.listing.currentPage,
                pagination: state => state.listing.pagination
			}),

            pagedItems() {
                let articles = JSON.parse(JSON.stringify(this.listing.slice((this.currentPage * 10) - 10, (this.currentPage * 10))));
                return articles.sort(function(a, b) { return new Date(b.PublishDate) - new Date(a.PublishDate)});
			}
		},
		components: {
            pagination: Pagination,
		},
        mounted: function () {
            let _this = this;

			// take props and send to vuex store
			this.setInitData(this.result);
			this.setResource(this.resource);

			// if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
            // // if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/updateSpecification') {
					this.setFilter();
				}
			});
		},
        methods: {
            ...mapActions('listing', { setFilter: 'setFilter' }),
            ...mapMutations('listing', { setInitData: 'setInitData' }),
            ...mapMutations('listing', { setResource: 'setResource' }),
            ...mapMutations('listing', { clearListing: 'clearListing' }),
            ...mapMutations('listing', { updateSpecification: 'updateSpecification' }),

            formatDate(theDate) {
                let d = new Date(theDate);
                let [month, day, year] = [d.toLocaleString('default', { month: 'short' }), d.getDate(), d.getFullYear()];
                let formattedDate = `${month} ${day}, ${year}`;
                return formattedDate;
            },
            truncate(text, length, suffix) {
                if (text.length > length) {
                    if(text.charAt( length - 1 ) === '.')
                    {
                        return text.substring(0, length - 1 ) + suffix; // remove extra dot
                    }
                    return text.substring(0, length) + suffix;
                } else {
                    return text;
                }
            }

        },
        
    }
</script>
